import Scrollbar, { ScrollbarPlugin } from 'smooth-scrollbar';
import ScrollTrigger from 'gsap/ScrollTrigger';

class AnchorPlugin extends ScrollbarPlugin {
    static pluginName = 'anchor';

    onHashChange = () => {
        this.jumpToHash(window.location.hash);
    };

    onClick = (event) => {
        const { target } = event;

        if (target.tagName !== 'A') {
            return;
        }

        const hash = target.getAttribute('href');

        if (!hash || hash.charAt(0) !== '#') {
            return;
        }

        this.jumpToHash(hash);
    };

    jumpToHash = (hash) => {
        const { scrollbar } = this;

        if (!hash) {
            return;
        }

        // reset scrollTop
        scrollbar.containerEl.scrollTop = 0;

        setTimeout(() => {
            scrollbar.scrollIntoView(document.querySelector(hash));
        }, 100);
    };

    onInit() {
        this.jumpToHash(window.location.hash);

        window.addEventListener('hashchange', this.onHashChange);

        this.scrollbar.contentEl.addEventListener('click', this.onClick);
    }

    onDestory() {
        window.removeEventListener('hashchange', this.onHashChange);

        this.scrollbar.contentEl.removeEventListener('click', this.onClick);
    }
}
class DisableScrollPlugin extends ScrollbarPlugin {
    static pluginName = 'disableScroll';

    static defaultOptions = {
        direction: '',
    };

    transformDelta(delta) {
        if (this.options.direction) {
            delta[this.options.direction] = 0;
        }

        return { ...delta };
    }
}
Scrollbar.use(AnchorPlugin);
Scrollbar.use(DisableScrollPlugin);

const scrollWrapper = document.querySelector('.js-scroll-wrapper');
const scrollCustom = document.querySelectorAll('.js-scroll-custom');

function scrollWrapperInit() {
    if (scrollWrapper) {
        document.documentElement.classList.add('is-smooth');
        window.scrollWrapper = Scrollbar.init(scrollWrapper, {
            plugins: {
                disableScroll: {
                    direction: 'x',
                },
            },
            renderByPixels: false,
        });
        window.scrollWrapper.addListener(ScrollTrigger.update);
        ScrollTrigger.scrollerProxy(scrollWrapper, {
            scrollTop(value) {
                if (arguments.length) {
                    window.scrollWrapper.scrollTop = value;
                }
                return window.scrollWrapper.scrollTop;
            },
            scrollLeft(value) {
                if (arguments.length) {
                    window.scrollWrapper.scrollLeft = value;
                }
                return window.scrollWrapper.scrollLeft;
            },
            getBoundingClientRect() {
                return { top: 0, left: 0, width: window.innerWidth, height: window.innerHeight };
            },
            pinType: 'transform',
        });
        ScrollTrigger.defaults({
            scroller: scrollWrapper,
        });
        window.addEventListener('beforeunload', () => {
            history.replaceState({ data: window.scrollWrapper.scrollTop }, '');
        });
        if (history.state) {
            setTimeout(() => {
                window.scrollWrapper.setPosition(0, history.state.data);
            }, 150);
        }
    }
}

function scrollCustomInit() {
    if (scrollCustom.length > 0) {
        scrollCustom.forEach((element) => {
            document.documentElement.classList.add('is-smooth');
            window.scrollCustom = Scrollbar.init(element, {
                renderByPixels: false,
            });
        });
    }
}

function scrollInit() {
    scrollWrapperInit();
    scrollCustomInit();
}

function init() {
    scrollInit();
}

function refresh() {
    ScrollTrigger.addEventListener('refresh', () => window.scrollWrapper.update());
    ScrollTrigger.refresh();
    window.scrollWrapper.update();
}

function update() {
    window.scrollWrapper.update();
    ScrollTrigger.refresh();
    window.dispatchEvent(new Event('resize'));
}

const _module = { init, refresh, update };

export default _module;
